import { isPublic, userHasRouteAccess, userHasRouteOrganisations, userHasRoutePermissions } from '@core/router/utils';
import { Auth } from '@core/auth';

const redirectRestrictedRoute = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else if (Auth().is_initialised) {
        const redirect = Auth().home_route;

        if (!userHasRoutePermissions(to)) {
            next(redirect);
            return false;
        }

        if (!userHasRouteOrganisations(to)) {
            next(redirect);
            return false;
        }

        if (!userHasRouteAccess(to)) {
            next(redirect);
            return false;
        }

        next();
    } else {
        next();
    }
};

export default redirectRestrictedRoute;
